// Common components barrel export
export { SAPIGlobe } from "./Logo";
export { PageHeader } from "./PageHeader";
export { PageFooter } from "./PageFooter";
export { EnhancedFooter } from "./EnhancedFooter";
export { PageLayout } from "./PageLayout";
export { COLORS, LAYOUT, TYPOGRAPHY } from "./constants";
